import { Box, Center, Group, Text, ThemeIcon } from '@mantine/core';
import { IconMapRoute } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';

import { LanguageSwitcher } from './language-switcher';

export const AuthLayout = () => {
    const { t } = useTranslation();

    return (
        <Box
            mih='100vh'
            pos='relative'
            style={{
                background:
                    'radial-gradient(1200px 600px at 80% -10%, var(--mantine-color-blue-0), transparent), linear-gradient(160deg, #F4F7FB 0%, #E8EEF5 100%)',
            }}
        >
            <Box pos='absolute' style={{ top: 16, right: 16 }}>
                <LanguageSwitcher size='sm' />
            </Box>
            <Center mih='100vh' p='md'>
                <Box w='100%' maw={480}>
                    <Group justify='center' gap='xs' mb='xl'>
                        <ThemeIcon size={34} radius='md' variant='filled' color='brand'>
                            <IconMapRoute size={20} />
                        </ThemeIcon>
                        <Box>
                            <Text fw={700} size='md' lh={1.1}>
                                Routellers
                            </Text>
                            <Text size='xs' c='dimmed' lh={1.1}>
                                {t('layout.admin')}
                            </Text>
                        </Box>
                    </Group>

                    <Outlet />
                </Box>
            </Center>
        </Box>
    );
};
